module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"查看原文":"View Original"},"zh":{"查看原文":"查看原文"}}')
  delete Component.options._Ctor
}
